/* angular libs */
import { NgModule } from '@angular/core';

/* pipe */
import { FormatDatePipe } from './format-date.pipe';


@NgModule({
  imports: [
  ],
  providers: [
  ],
  declarations: [
    FormatDatePipe
  ],
  exports: [
    FormatDatePipe
  ]
})
export class FormatDateModule {
}
